import React from "react";
import { Button } from "@/components/Calendar/ui/button";
import { Save, X, Loader2 } from "lucide-react";

interface SaveDefaultViewBarProps {
  isDarkMode: boolean;
  onSave: () => void;
  onDismiss: () => void;
  isSaving?: boolean;
}

export function SaveDefaultViewBar({
  isDarkMode,
  onSave,
  onDismiss,
  isSaving = false,
}: SaveDefaultViewBarProps) {
  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-50 border-t shadow-lg transition-all duration-300 ${
        isDarkMode ? "bg-gray-800 border-gray-700" : "bg-white border-gray-200"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className={`w-2 h-2 rounded-full bg-blue-500 animate-pulse`} />
            <p
              className={`text-sm font-medium ${
                isDarkMode ? "text-white" : "text-gray-900"
              }`}
            >
              You've customized your view settings
            </p>
            <p
              className={`text-sm ${
                isDarkMode ? "text-gray-400" : "text-gray-600"
              }`}
            >
              Would you like to save this as your default view?
            </p>
          </div>
          <div className="flex items-center gap-2">
            <Button
              variant="ghost"
              size="sm"
              onClick={onDismiss}
              disabled={isSaving}
              className={
                isDarkMode
                  ? "text-gray-400 hover:text-white hover:bg-gray-700"
                  : "text-gray-600 hover:text-gray-900"
              }
            >
              <X className="w-4 h-4 mr-1" />
              Dismiss
            </Button>
            <Button
              size="sm"
              onClick={onSave}
              disabled={isSaving}
              className="bg-black hover:bg-gray-900 text-white disabled:opacity-60 cursor-pointer disabled:cursor-not-allowed"
            >
              {isSaving ? (
                <>
                  <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                  Saving...
                </>
              ) : (
                <>
                  <Save className="w-4 h-4 mr-2" />
                  Save as Default
                </>
              )}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
